module.exports = __webpack_public_path__ + "static/media/mybook.c0c1f46b.png";